import React from "react";

import useSearchStore from "../../_Global/SearchStore";

interface ResultsPerPageConfiguration {
    selectOptions: {
        label: string;
        value: string;
    }[];
}

function ResultsPerPage( {selectOptions}: ResultsPerPageConfiguration ) {
    const funnelbackQueryParameters = useSearchStore(
        (state) => state.funnelbackQueryParameters
    );

    const setFunnelbackQueryParameters = useSearchStore(
        (state) => state.setFunnelbackQueryParameters
    );

    const onSortOptionChange = (evt: React.ChangeEvent<HTMLSelectElement>) => {
        const newValue = evt.target.value;
        setFunnelbackQueryParameters({
            num_ranks: parseInt(newValue, 10)
        });
    };

    return (
        <div>
            <label htmlFor="search--limit">Limit:</label>
            <select
                id="search--limit"
                name="num_ranks"
                className=""
                onChange={onSortOptionChange}
                value={funnelbackQueryParameters["num_ranks"]}
            >
                {
                    selectOptions.map(option => {
                        return (
                            <option
                                key={option["value"]}
                                value={option["value"]}
                            >{option["label"]}</option>
                        )
                    })
                }
            </select>
      </div>
    );
}

export default React.memo(ResultsPerPage);
